<template>
  <v-navigation-drawer v-model="stateDrawer" fixed right temporary width="800" class="width-menu">
    <div>
      <div class="filter-header">
        <div class="d-flex align-center justify-space-between">
          <span class="font-w-500 font-20">กรองการค้นหา</span>
          <img src="img/icons_v2/icon-close-black.png" @click="$emit('toggleDrawer')" />
        </div>
      </div>

      <div>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div>
                <span class="font-20 pr-3">หมวดหมู่</span>
                <v-avatar color="#A9182A" size="36">
                  <span class="font-14" style="color: white !important;">{{ groupCount }}</span>
                </v-avatar>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <!-- input search group -->
              <div class="my-4">
                <v-text-field
                  v-model="searchGroupInput"
                  outlined
                  append-icon="mdi-magnify"
                  hide-details
                  placeholder="ค้นหา"
                />
              </div>

              <!-- content data group -->
              <div>
                <v-row class="scroll-filter">
                  <v-col
                    v-for="(item, index) in filteredGroup"
                    :key="index"
                    cols="6"
                    @click="selectGroup(item)"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          class="box-items"
                          :class="selectGroupActive(item.id) == true ? 'active' : ''"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <span class="text-overflows">{{ item.class_name }}</span>
                        </div>
                      </template>

                      <span>{{ item.class_name }}</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div>
                <span class="font-20 pr-3">Brand</span>
                <v-avatar color="#A9182A" size="36">
                  <span class="font-14" style="color: white !important;">{{ brandCount }}</span>
                </v-avatar>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <!-- input search group -->
              <div class="my-4">
                <v-text-field
                  v-model="searchBrandInput"
                  outlined
                  append-icon="mdi-magnify"
                  hide-details
                  placeholder="ค้นหา"
                />
              </div>

              <!-- content data brand -->
              <div>
                <v-row class="scroll-filter">
                  <v-col
                    v-for="(item, index) in filteredBrand"
                    :key="index"
                    cols="6"
                    @click="selectBrand(item)"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          class="box-items"
                          :class="selectBrandActive(item.id) == true ? 'active' : ''"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <span class="text-overflows">{{ item.name }}</span>
                        </div>
                      </template>

                      <span>{{ item.name }}</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>

      <div class="filter-footer">
        <div class="d-flex justify-space-between">
          <button type="button" class="button-filter" @click="cancelFilter">
            ล้างฟิลเตอร์
          </button>
          <button type="button" class="button-filter submit" @click="saveFilter">
            ตกลง
          </button>
        </div>
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script>
export default {
  props: ['drawer'],

  data() {
    return {
      groupCount: 0,
      brandCount: 0,
      group: [],
      brand: [],
      select_group: [],
      select_brand: [],
      select_temp: [],
      select_temp_brand: [],
      show: false,
      searchGroupInput: '',
      searchBrandInput: ''
    }
  },

  watch: {
    stateDrawer(newValue) {
      if (newValue) {
        this.getGroupBrandProduct()

        this.select_group.forEach((element) => {
          this.selectGroup(element)
        })

        this.select_brand.forEach((element) => {
          this.selectBrand(element)
        })
      } else {
        this.select_temp = []
        this.select_temp_brand = []
      }
    }
  },

  computed: {
    stateDrawer: {
      get() {
        return this.drawer
      },
      set(value) {
        if (!value) {
          this.$emit('toggleDrawer')
        }
      }
    },

    filteredGroup() {
      if (this.searchGroupInput === '') {
        return this.group
      } else {
        const keyword = this.searchGroupInput.toLowerCase()
        return this.group.filter((item) => item.class_name.toLowerCase().includes(keyword))
      }
    },

    filteredBrand() {
      if (this.searchBrandInput === '') {
        return this.brand
      } else {
        const keyword = this.searchBrandInput.toLowerCase()
        return this.brand.filter((item) => item.name.toLowerCase().includes(keyword))
      }
    }
  },

  methods: {
    selectGroup(item) {
      console.log(item)
      const data = this.select_temp
      var check = false
      data.forEach((element, index) => {
        if (element.id == item.id) {
          check = true
          this.select_temp.splice(index, 1)
        }
      })
      if (!check) {
        this.select_temp.push(item)
      }
    },

    selectBrand(item) {
      const data = this.select_temp_brand
      var check = false
      data.forEach((element, index) => {
        if (element.id == item.id) {
          check = true
          this.select_temp_brand.splice(index, 1)
        }
      })
      if (!check) {
        this.select_temp_brand.push(item)
      }
    },

    selectGroupActive(id) {
      const data = this.select_temp
      var check = false
      data.forEach((element) => {
        if (element.id == id) {
          check = true
        }
      })
      return check
    },

    selectBrandActive(id) {
      const data = this.select_temp_brand
      var check = false
      data.forEach((element) => {
        if (element.id == id) {
          check = true
        }
      })
      return check
    },

    cancelFilter() {
      this.select_temp = []
      this.select_group = []
      this.select_temp_brand = []
      this.select_brand = []
      this.$emit('cancel')
      this.$emit('toggleDrawer')
    },

    saveFilter() {
      this.select_group = this.select_temp
      this.select_brand = this.select_temp_brand

      this.$emit('filter', this.select_group, this.select_brand)
      this.$emit('toggleDrawer')

      this.select_temp = []
      this.select_temp_brand = []
    },

    getGroupBrandProduct() {
      const data = { method: 'GET', headers: this.setheaders }

      // group
      fetch(`${this.$baseAPIControl}/product/productGroup`, data)
        .then((response) => {
          return response.json()
        })
        .then((res) => {
          this.group = res.items
          this.groupCount = res.items.length
        })
        .catch((error) => {
          console.log(error)
        })

      // brand
      fetch(`${this.$baseAPIControl}/product/productBrand`, data)
        .then((response) => {
          return response.json()
        })
        .then((res) => {
          this.brand = res.items
          this.brandCount = res.items.length
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.filter {
  &-header {
    padding: 30px 20px;
    background-color: #e1e1e1;
    margin-top: 4rem;
  }

  &-footer {
    position: absolute;
    width: 100%;
    padding: 30px;
    bottom: 0;
    border-top: 1px solid rgba(202, 202, 202, 0.5);
  }
}

.box-items {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  border-radius: 5px;
  border: solid 1px #dedede;
  background-color: #fff;
  padding: 24px;

  &.active {
    border: 1px solid #ac0300;
    background-color: rgba(172, 3, 0, 0.1);
  }
}

.button-filter {
  width: 150px;
  border-radius: 9px;
  height: 70px;
  font-size: 20px;
  font-weight: 500;
  border: 1px solid #c4c4c4;

  &.submit {
    background-color: #a50200;
    color: #ffffff;
  }
}

.scroll-filter {
  max-height: 600px;
  // height: 625px;
  overflow: scroll;
}

.text-overflows {
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  font-size: 18px !important;
}
</style>
